import React from 'react';
import { Box, Text, Flex } from 'rebass/styled-components';
import { Button } from '@getro/rombo';
import PropTypes from 'prop-types';
import { CONTACT_AGENT_BOOST_MEETING_URL } from '../../../helpers/constants';

export const CampaignEmptyState = ({ statuses, status }) => {
  const emptyState = statuses[status];

  return (
    <Flex
      sx={{
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '24px',
        mt: '80px',
        maxWidth: '480px',
        mx: 'auto',
      }}
    >
      <Box as={emptyState.icon} width="100px" height="100px" />
      <Flex sx={{ flexDirection: 'column', gap: '8px', alignItems: 'center' }}>
        <Text
          sx={{
            color: 'text.dark',
            textAlign: 'center',
            fontSize: '14px',
            fontWeight: '500',
            lineHeight: '120%',
          }}
        >
          {emptyState.title}
        </Text>
        {emptyState.description && (
          <Flex
            sx={{
              flexDirection: 'column',
              gap: '8px',
              color: 'text.main',
              textAlign: 'center',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '140%',
            }}
          >
            {emptyState.description.map((description) => (
              <Text key={description}>{description}</Text>
            ))}
          </Flex>
        )}
        {emptyState.action && (
          <Box>
            <Button as="a" href={CONTACT_AGENT_BOOST_MEETING_URL} target="_blank" rel="noopener noreferrer">
              {emptyState.action.text}
            </Button>
          </Box>
        )}
      </Flex>
    </Flex>
  );
};

CampaignEmptyState.propTypes = {
  status: PropTypes.string.isRequired,
  statuses: PropTypes.object.isRequired,
};
